



import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

// https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage
const sourceCodeModeLocalStorageKey = "DashboardGridModeToggle.sourceCodeMode";

@Component
export default class DashboardGridModeToggle extends Vue {
    @Prop({ required: true })
    value!: boolean;

    get sourceCodeMode(): boolean {
        return (
            window.localStorage.getItem(sourceCodeModeLocalStorageKey) ===
            true.toString()
        );
    }
    set sourceCodeMode(value: boolean) {
        window.localStorage.setItem(
            sourceCodeModeLocalStorageKey,
            value.toString()
        );

        this.$emit("input", value);
    }

    mounted() {
        // When the component gets mounted, overwrite any default value the parent component has set
        // because this switch is supposed to persist it's value across requests.
        this.$emit("input", this.sourceCodeMode);
    }
}
